import React, { useState, useRef, forwardRef, useEffect } from "react";
import DatePicker, { CalendarContainer } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./ScheduleTraining.scss";
import moment from "moment";
import setHours from "date-fns/setHours";
import setMinutes from "date-fns/setMinutes";
import Button from "../../common/Button";
import setSeconds from "date-fns/setSeconds";
import { Grid, Typography } from "@mui/material";
import Calendar from "../../../Images/Icon metro-calendar.svg";
import Clock from "../../../Images/Icon feather-clock.svg";
import Arrow from "../../../Images/Icon awesome-arrow-right.svg";
import CancelImage from "../../../Images/CancelIcon.svg";
import { padding, Stack } from "@mui/system";
import { Button as MyButton } from "@mui/material";
import { toast } from "react-toastify";
import {
  scheduleTraining,
  cloudType,
} from "../../../redux/features/CreateSessionReducer";
import { useDispatch, useSelector } from "react-redux";
import { add, after, indexOf } from "lodash";
import { TrainingList } from "../../../redux/features/CreateSession";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { Item } from "semantic-ui-react";
import api_call from "../../../globals/common_utilities/axios_old";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import { API } from "../../../globals/constants";
import MultiLine_Spinner from "../../multiline_spinner/Multiline_spinner";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { styled } from "@mui/material/styles";
import FormGroup from "@mui/material/FormGroup";

function ScheduleTraining(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [date, setDate] = useState([
    {
      startDate: setHours(setMinutes(setSeconds(new Date(), 0), 0), 0),
      endDate: "",
      startTime: "",
      endTime: "",
      sequence: 0,
      days: [],
    },
  ]);
  const [startDate, setStartDate] = useState(
    setHours(setMinutes(setSeconds(new Date(), 0), 0), 0)
  );
  const [endDate, setEndDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [pushdata, setpushdata] = useState([]);
  const [days, setDays] = useState([
    {
      id: "Sun",
      key: false,
      name: "Sunday",
    },
    {
      id: "Mon",
      key: false,
      name: "Monday",
    },
    {
      id: "Tue",
      key: false,
      name: "Tuesday",
    },
    {
      id: "Wed",
      key: false,
      name: "Wednesday",
    },
    {
      id: "Thu",
      key: false,
      name: "Thursday",
    },
    {
      id: "Fri",
      key: false,
      name: "Friday",
    },
    {
      id: "Sat",
      key: false,
      name: "Saturday",
    },
  ]);
  const [message, setMessage] = useState(0);
  const [selectedDays, setSelectedDays] = useState([]);
  const [trainingVal, setTrainingVal] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [getDays, setgetDays] = useState([]);
  const [gcpSchedule, setGcpSchedule] = useState("Right Now");
  const [daysOpted, setDaysOpted] = useState([]);
  const trainingData = useSelector((state) => {
    return state;
  });
  const trainingDetails = useSelector((state) => {
    return state?.TrainingById;
  });
  const selectedSessionOption = useSelector((state) => {
    console.log("chk the state value ----", state);
    return state?.CreateSession?.cloudType;
  });
  const sessionDate = useSelector((state) => {
    return state?.CreateSession?.scheduleTraining;
  });
  const endTimeRef = useRef(null);

  useEffect(() => {}, [date]);
  useEffect(() => {
    if (props.action === "reschedule") {
      getTrainingData();
    }
  }, [trainingDetails?.TrainingById]);
  useEffect(() => {
    if (props.action === "reschedule") {
      let params = {
        tid: props?.training,
      };

      dispatch(
        TrainingList({
          params,
        })
      );
    }
  }, []);
  useEffect(() => {
    if (props?.action === "reschedule") {
    } else {
      console.log("sessionDate====", sessionDate?.training_date);
      if (sessionDate !== "") {
        if (selectedSessionOption?.sessionType === "longtermsession") {
          setStartDate(
            sessionDate?.training_date
              ? sessionDate?.training_date[0]?.session_start_date
              : setHours(setMinutes(setSeconds(new Date(), 0), 0), 0)
          );
          setEndDate(
            sessionDate?.training_date
              ? sessionDate?.training_date[0]?.session_end_date
              : ""
          );
          setStartTime(
            sessionDate?.training_date
              ? sessionDate?.training_date[0]?.session_start_date
              : ""
          );
          setEndTime(
            sessionDate?.training_date
              ? sessionDate?.training_date[0]?.session_end_date
              : ""
          );
          setGcpSchedule(selectedSessionOption?.gcpType);
        } else {
          let data = sessionDate?.training_data?.map((item) => {
            return {
              startDate: new Date(item.startDate),
              endDate: new Date(item.endDate),
              startTime: new Date(item.startTime),
              endTime: new Date(item.endTime),
              sequence: item.sequence,
              days: [...item.days],
            };
          });
          setpushdata(
            sessionDate?.training_date?.length > 0
              ? [...sessionDate?.training_date]
              : []
          );
          setDate(
            data
              ? [...data]
              : [
                  {
                    startDate: setHours(
                      setMinutes(setSeconds(new Date(), 0), 0),
                      0
                    ),
                    endDate: "",
                    startTime: "",
                    endTime: "",
                    sequence: 0,
                    days: [],
                  },
                ]
          );
          let selected_days = sessionDate?.training_data?.map((item, index) => {
            let temp = item.days.map((val) => {
              let data_day = selectedDays;
              data_day.push({
                id: val,
                index: index,
              });
            });

            return temp;
          });
        }
      } else {
      }
    }
  }, [sessionDate]);
  useEffect(() => {
    if (document.getElementById("endTime") !== null) {
      document.getElementById("endTime").value = "";
    }
    setEndTime("");
  }, [endDate]);
  useEffect(() => {
    if (document.getElementById("startTime") !== null) {
      document.getElementById("startTime").value = "";
    }
    setStartTime("");
  }, [startDate]);

  const BpIcon = styled("span")(({ theme }) => ({
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    border: "1px solid #fff",
    boxShadow:
      theme.palette.mode === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: theme.palette.mode === "dark" ? "#137cbd00" : "#137cbd00",
    "input:hover ~ &": {
      backgroundColor: "#137cbd00",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        theme.palette.mode === "dark"
          ? "rgba(57,75,89,.5)"
          : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: "#137cbd00",
    "&:before": {
      display: "block",
      width: "12px",
      height: "12px",
      backgroundColor: "#fff",
      content: '""',
      borderRadius: "50px",
      margin: "3px",
    },
  });

  function BpRadio(props) {
    return (
      <Radio
        sx={{
          "&:hover": {
            bgcolor: "transparent",
          },
        }}
        disableRipple
        color='default'
        checkedIcon={<BpCheckedIcon />}
        icon={<BpIcon />}
        {...props}
      />
    );
  }
  const handleTrainings = (event) => {
    // setSelectedValue(event.target.value);
    setGcpSchedule(event.target.value);
  };
  const handleStartDate = (val, index) => {
    let data = [...date];
    data[index].startDate = val;
    data[index].startTime = "";
    data[index].endTime = "";
    data[index].days = [];
    data[index].endDate = "";
    setDate([...data]);
    if (pushdata) {
      let temp = pushdata.filter((item) => item.sessions_week !== `w${index}`);
      setpushdata([...temp]);
      let selected_data = selectedDays.filter((item) => item.index !== index);
      console.log("selcteddays start date", selected_data);
      setSelectedDays([...selected_data]);
    }
  };

  const handleEndDate = (val, index, startDate) => {
    let data = [...date];
    data[index].endDate = val;
    data[index].startTime = "";
    data[index].endTime = "";
    data[index].days = [];
    setDate([...data]);
    if (pushdata) {
      let temp = pushdata.filter((item) => item.sessions_week !== `w${index}`);
      console.log("temp check ", temp);
      setpushdata([...temp]);
      let selected_data = selectedDays.filter((item) => item.index !== index);
      console.log("selcteddays end date", selected_data);
      setSelectedDays([...selected_data]);
    }

    if (
      moment(val).format("YYYY-MM-DD") ===
      moment(startDate).format("YYYY-MM-DD")
    ) {
      console.log("chk the value");
      let finaldate = {
        day: moment(new Date(startDate)).format("ddd"),
        sessions_week: `w${[index]}`,
      };
      let date_value = date;
      date_value[index].days = [finaldate.day];
      setDate([...date_value]);
      let selected_days = {
        id: finaldate.day,
        index: index,
      };
      console.log("selcteddays EndDate", [...selectedDays, selected_days]);
      setSelectedDays([...selectedDays, selected_days]);
    }
  };
  const handleStartTime = (val, index) => {
    console.log("Schedule1 start time ", val);
    let data = [...date];
    data[index].startTime = val;
    data[index].endTime = "";
    setDate([...data]);
    if (pushdata) {
      let weekCount = `w${index}`;
      let dataFilter = pushdata.map((item) => {
        if (weekCount !== item.sessions_week) {
          return {
            session_start_date: moment(item.session_start_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            sessions_week: item.sessions_week,
            session_end_date: moment(item.session_end_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            day: item.day,
          };
        } else {
          return {
            session_start_date: moment(item.session_start_date).format(
              `YYYY-MM-DD ${moment(val).format("HH:mm:ss")}`
            ),
            sessions_week: item.sessions_week,
            session_end_date: moment(item.session_end_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            day: item.day,
          };
        }
      });
      setpushdata([...dataFilter]);
    }
  };
  const handleEndTime = (val, index, startDate, endDate, startTime) => {
    let data = [...date];
    let schedule_data = [];
    data[index].endTime = val;
    setDate([...data]);
    if (pushdata) {
      let weekCount = `w${index}`;
      let dataFilter = pushdata.map((item) => {
        if (weekCount !== item.sessions_week) {
          return {
            session_start_date: moment(item.session_start_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            sessions_week: item.sessions_week,
            session_end_date: moment(item.session_end_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            day: item.day,
          };
        } else {
          return {
            session_start_date: moment(item.session_start_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            sessions_week: item.sessions_week,
            session_end_date: moment(item.session_end_date).format(
              `YYYY-MM-DD ${moment(val).format("HH:mm:ss")}`
            ),
            day: item.day,
          };
        }
      });
      schedule_data = [...dataFilter];
      setpushdata([...dataFilter]);
    }
    if (
      moment(endDate).format("YYYY-MM-DD") ===
      moment(startDate).format("YYYY-MM-DD")
    ) {
      console.log("chk condition");
      let finaldate = {
        session_start_date: moment(new Date(startDate)).format(
          `YYYY-MM-DD ${moment(startTime).format("HH:mm:ss")}`
        ),
        session_end_date: moment(new Date(endDate)).format(
          `YYYY-MM-DD ${moment(val).format("HH:mm:ss")}`
        ),
        day: moment(new Date(endDate)).format("ddd"),
        sessions_week: `w${[index]}`,
      };
      let date_filter = pushdata.filter(
        (item) =>
          item.sessions_week === finaldate.sessions_week &&
          item.day === finaldate.day &&
          moment(item.session_end_date).format("YYYY-MM-DD") ===
            moment(finaldate.session_end_date).format("YYYY-MM-DD")
      );
      setpushdata(
        date_filter.length > 0 ? [...schedule_data] : [...pushdata, finaldate]
      );
    }
  };
  const disableStartTimeGcp = (val) => {
    let now = moment().toDate();
    var date = moment(now).add(45, "m").toDate();
    var minDate = moment(now).add(45, "m").toDate();
    console.log(
      "check the gcp start date -----",
      val.getTime() < new Date().getTime()
    );
    return val.getTime() < new Date().getTime()
      ? {
          minTime: minDate,
          maxTime: setHours(setMinutes(now, 59), 23),
        }
      : {
          minTime: setHours(setMinutes(now, 0), 24),
          maxTime: setHours(setMinutes(now, 59), 23),
        };
  };
  const disableEndTimeGcp = (val) => {
    let now = moment().toDate();
    console.log("check end date hkjhkjzxkjzxcjk", endDate > startDate);
    var minDate = moment(now).add(45, "m").toDate();
    return endDate > startDate
      ? {
          minTime: setHours(setMinutes(now, 0), 24),
          maxTime: setHours(setMinutes(now, 59), 23),
        }
      : {
          minTime: minDate,
          maxTime: setHours(setMinutes(now, 59), 23),
        };
  };
  const disableStartTime = (val, index) => {
    console.log(
      "rtytwreq",
      setHours(setMinutes(setSeconds(val, 0), 0), 0),
      val.getTime(),
      new Date().getTime()
    );
    let val_date = setHours(setMinutes(setSeconds(val, 0), 0), 0);
    let now = moment().toDate();
    var minDate = moment(now).add(45, "m").toDate();
    if (index === 0) {
      console.log("condition 1");
      return val_date.getTime() < new Date().getTime()
        ? {
            minTime: minDate,
            maxTime: setHours(setMinutes(now, 59), 23),
          }
        : {
            minTime: setHours(setMinutes(now, 0), 24),
            maxTime: setHours(setMinutes(now, 59), 23),
          };
    } else {
      let temp = date.map((item, i) => {
        if (i === index) {
        } else {
          return moment(item.startDate).format("YYYY-MM-DD");
        }
      });
      let value_date = moment(val).format("YYYY-MM-DD");
      if (temp.includes(value_date)) {
        console.log("condition 2");
        let temp_data = temp.lastIndexOf(value_date);
        let start_disable = moment(date[temp_data].endTime)
          .add(60, "m")
          .toDate();
        return {
          minTime: start_disable,
          maxTime: setHours(setMinutes(now, 59), 23),
        };
      } else {
        console.log("condition 3");
        return val_date.getTime() < new Date().getTime()
          ? {
              minTime: minDate,
              maxTime: setHours(setMinutes(now, 59), 23),
            }
          : {
              minTime: setHours(setMinutes(now, 0), 24),
              maxTime: setHours(setMinutes(now, 59), 23),
            };
      }
    }
  };
  const disable_start_time = (val) => {
    console.log("check start time val", val);
  };
  const handleScheduler = (temp, index) => {
    let data = [...date];
    data.push({
      startDate: new Date(),
      endDate: "",
      startTime: "",
      endTime: "",
      sequence: data.length,
      days: [],
    });
    setDate([...data]);
  };
  const disableEndTime = (startTime, startDate, endDate) => {
    const now = moment().toDate();

    return endDate > startDate
      ? {
          minTime: setHours(setMinutes(now, 0), 24),
          maxTime: setHours(setMinutes(now, 59), 23),
        }
      : {
          minTime: startTime,
          maxTime: setHours(setMinutes(now, 59), 23),
        };
  };
  const sortDays = (val, index) => {
    let days = [...date];
    let data = val;
    let temp = [];
    if (days[index].days.includes(val)) {
      setDate([...days]);
    } else {
      let selectedValue = "";
      selectedValue = days[index].days;
      selectedValue.push(val);
      setDate([...days]);
    }
  };
  const isValid = async () => {
    console.log("check the data for validation", date);
    let data = [...date];
    let error = false;
    let err_data = [];
    let temp = data.forEach((item) => {
      console.log("check the is valid data ", item);
      if (item.endDate === "" && item.startTime === "" && item.endTime === "") {
        toast.error(`Please fill the fields`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: "field",
          style: { background: "#000", color: "#ffffff" },
        });
        let data = [...err_data];
        data.push(true);
        err_data = [...data];
        return (error = true);
      } else if (item.startDate === "") {
        toast.error(`Please select start date`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: "field",
          style: { background: "#000", color: "#ffffff" },
        });
        let data = [...err_data];
        data.push(true);
        err_data = [...data];
        return (error = true);
      } else if (item.endDate === "") {
        toast.error(`Please select end date`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          toastId: "field",
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        let data = [...err_data];
        data.push(true);
        err_data = [...data];
        return (error = true);
      } else if (item.startTime === "") {
        toast.error(`Please select start time`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: "field",
          style: { background: "#000", color: "#ffffff" },
        });
        let data = [...err_data];
        data.push(true);
        err_data = [...data];
        return (error = true);
      } else if (item.endTime === "") {
        toast.error(`Please select end time`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: "field",
          style: { background: "#000", color: "#ffffff" },
        });
        let data = [...err_data];
        data.push(true);
        err_data = [...data];
        return (error = true);
      } else if (item.days.length === 0) {
        toast.error(`Please select days`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          toastId: "field",
          style: { background: "#000", color: "#ffffff" },
        });
        let data = [...err_data];
        data.push(true);
        err_data = [...data];
        return (error = true);
      } else {
        return (error = false);
      }
    });
    console.log("check the error data value----", err_data);
    return err_data;
  };
  const valid = () => {
    let error = false;
    if (gcpSchedule === "Schedule") {
      if (endDate === "" && startTime === "" && endTime === "") {
        toast.error(`Please fill the fields`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      } else if (startDate === "") {
        toast.error(`Please select start date`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      } else if (endDate === "") {
        toast.error(`Please select end date`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      } else if (startTime === "") {
        toast.error(`Please select start time`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      } else if (endTime === "") {
        toast.error(`Please select end time`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      }
    } else {
      if (endDate === "" && endTime === "") {
        toast.error(`Please fill the fields`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      } else if (endDate === "") {
        toast.error(`Please select end date`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      } else if (endTime === "") {
        toast.error(`Please select end time`, {
          position: "bottom-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: { background: "#000", color: "#ffffff" },
        });
        return (error = true);
      }
    }
    return error;
  };
  const cookies = new Cookies();
  const { email_id, id, name, role_code, studio_id } = cookies.get("loginData");
  const onSubmit = async () => {
    if (
      selectedSessionOption.sessionType === "longtermsession"
        ? !valid()
        : !(await isValid()).includes(true)
    ) {
      let data = [...date];
      let start_Date = "";
      let end_Date = "";

      let temp = data.map((value, index) => {
        let start_date = moment(value.startDate).format(
          `YYYY-MM-DD ${moment(value.startTime).format("HH:mm:ss")}`
        );
        let end_date = moment(value.endDate).format(
          `YYYY-MM-DD ${moment(value.endTime).format("HH:mm:ss")}`
        );

        return { start_date, end_date };
      });
      const maxDate = new Date(
        Math.max(
          ...temp.map((element) => {
            return new Date(element.end_date);
          })
        )
      );
      const minDate = new Date(
        Math.min(
          ...temp.map((element) => {
            return new Date(element.start_date);
          })
        )
      );
      start_Date = minDate;
      end_Date = maxDate;
      let selectDay = selectedDays.map((item) => {
        return item.id;
      });
      console.log("value chk---", selectDay);
      let training_days = selectDay.filter(
        (item, index) => selectDay.indexOf(item) === index
      );
      console.log(
        "training_days",
        selectDay.filter((item, index) => selectDay.indexOf(item) === index)
      );
      if (selectedSessionOption?.sessionType === "longtermsession") {
        let dates = [];
        let starttime = moment().format("HH:mm:ss");
        let endtime = moment(endTime).format("HH:mm:ss");
        const theDate = setHours(
          setMinutes(setSeconds(new Date(startDate), 0), 0),
          0
        );
        console.log("check dates00000000000======", starttime, endtime);
        while (
          new Date(moment(theDate).format("MM/DD/YYYY")) <=
          new Date(moment(endDate).format("MM/DD/YYYY"))
        ) {
          let end_time = moment(theDate, "YYYY-MM-DD").add("days", 1);
          let finaldate = {
            session_start_date: moment(new Date(theDate)).format(
              `YYYY-MM-DD ${moment(startTime).format("HH:mm:ss")}`
            ),
            session_end_date: end_time.format(
              `YYYY-MM-DD ${moment(endTime).format("HH:mm:ss")}`
            ),
            day: moment(new Date(theDate)).format("ddd"),
            sessions_week: `w0`,
          };
          dates.push(finaldate);
          theDate.setDate(theDate.getDate() + 1);
          console.log("before dates----", dates);
        }
        let daysSelected = dates.map((item) => {
          let filterData = daysOpted.filter((val) => val === item.day);
          console.log("check filter date====", filterData);
          if (filterData.length > 0) {
          } else {
            let days = daysOpted;
            days.push(item.day);
            setDaysOpted([...days]);
          }
        });
      }
      if (props.action === "reschedule") {
        let training_dates_data = pushdata.map((item) => {
          return {
            ...item,
            session_end_date: moment(item.session_end_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
            session_start_date: moment(item.session_start_date).format(
              "YYYY-MM-DD HH:mm:ss"
            ),
          };
        });
        let training_dates_orderby = training_dates_data.sort(
          (a, b) =>
            a.sessions_week.split("w")[1] - b.sessions_week.split("w")[1]
        );
        console.log("chk_date", training_dates_orderby);
        let params = {
          tid: props.training,
        };
        const {
          title,
          machine_ami_id,
          region_code,
          zone,
          instance_id,
          is_private,
          feedback_template_id,
          session_start_date,
          training_date,
          days,
          tags,
          session_end_date,
          description,
          instructor_id,
          studio_id,
          host,
          is_active,
          created_by,
          student,
        } = trainingVal;
        let bodyParam = {
          title: title,
          machine_ami_id: machine_ami_id,
          region_code: region_code,
          zone: zone,
          instance_id: instance_id,
          feedback_template_id: feedback_template_id,
          session_start_date: moment(start_Date).format("YYYY-MM-DD HH:mm:ss"),
          is_private: is_private,
          days: JSON.stringify(training_days),
          tags: tags,
          session_end_date: moment(end_Date).format("YYYY-MM-DD HH:mm:ss"),
          description: description,
          is_all_day: false,
          instructor_id: instructor_id,
          studio_id: studio_id,
          host: host,
          is_active: is_active,
          created_by: created_by,
          student: student ? student : [],
          updatedBy: id,
          training_date: [...training_dates_orderby],
        };
        setIsloading(true);
        console.log("bjhghgkjgkgghkj0---", bodyParam);
        const response = await api_call(
          "post",
          `${
            CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].TRAINING +
            API.END_POINTS.RESCHEDULE
          }`,
          params,
          {},
          bodyParam
        );

        if (response.status === 200) {
          setIsloading(false);
          navigate("/training");
          toast.success(`Your training has been rescheduled`, {
            position: "bottom-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            style: { background: "#000", color: "#ffffff" },
          });
        } else {
          setIsloading(false);
        }
      } else {
        console.log(
          "chk dispatch",
          start_Date,
          end_Date,
          [...pushdata],
          [...date],
          [...training_days]
        );
        dispatch(
          scheduleTraining({
            session_start_date:
              selectedSessionOption?.sessionType === "longtermsession"
                ? gcpSchedule === "Schedule"
                  ? startDate
                  : startDate
                : start_Date,
            session_end_date:
              selectedSessionOption?.sessionType === "longtermsession"
                ? gcpSchedule === "Schedule"
                  ? endDate
                  : endDate
                : end_Date,
            training_date:
              selectedSessionOption?.sessionType === "longtermsession"
                ? gcpSchedule === "Schedule"
                  ? [
                      {
                        session_start_date: moment(new Date(startDate)).format(
                          `YYYY-MM-DD ${moment(startTime).format("HH:mm:ss")}`
                        ),
                        session_end_date: moment(endDate).format(
                          `YYYY-MM-DD ${moment(endTime).format("HH:mm:ss")}`
                        ),
                        day: moment(startDate).format("ddd"),
                        sessions_week: `w0`,
                      },
                    ]
                  : [
                      {
                        session_start_date: moment(new Date(startDate)).format(
                          `YYYY-MM-DD ${moment(startDate).format("HH:mm:ss")}`
                        ),
                        session_end_date: moment(endDate).format(
                          `YYYY-MM-DD ${moment(endTime).format("HH:mm:ss")}`
                        ),
                        day: moment(startDate).format("ddd"),
                        sessions_week: `w0`,
                      },
                    ]
                : [...pushdata],
            training_data:
              selectedSessionOption?.sessionType === "longtermsession"
                ? [
                    {
                      startDate: new Date(startDate),
                      endDate: new Date(endDate),
                      startTime:
                        gcpSchedule === "Schedule"
                          ? new Date(startTime)
                          : new Date(startDate),
                      endTime: new Date(endTime),
                      sequence: 0,
                      days: [...days],
                    },
                  ]
                : [...date],
            days:
              selectedSessionOption?.sessionType === "longtermsession"
                ? [...daysOpted]
                : [...training_days],
          }),

          dispatch(
            cloudType({
              sessionType: selectedSessionOption?.sessionType,
              gcpType:
                selectedSessionOption?.sessionType === "longtermsession"
                  ? gcpSchedule
                  : "",
            })
          )
        );
        props.handleNext();
      }
    } else {
    }
  };
  const onCross = (index) => {
    if (index === 0) {
    } else {
      let data = [...date];
      data.splice(index, 1);
      setDate([...data]);
      let str = `w${index}`;
      let changeScheduleData = pushdata.filter(
        (item) => item.sessions_week !== str
      );
      setpushdata([...changeScheduleData]);
      console.log("changeScheduleData====", changeScheduleData);
      let temp_data = [];
      const trainingDataRead = changeScheduleData.map((item, i) => {
        if (item.sessions_week === "w0") {
          let temp = temp_data;
          temp.push(item);
          temp_data = temp;
          return item;
        } else {
          let sessionWeak = item.sessions_week.split("w")[1] - 1;
          console.log("sessionWeak====", sessionWeak);
          let string = `w${sessionWeak}`;
          let WeakOfSession = `w${sessionWeak + 1}`;
          let schedule_filter = changeScheduleData.filter(
            (item) => item.sessions_week === WeakOfSession
          );
          let filtertemp_data = temp_data.filter(
            (val) => val.sessions_week === string
          );
          console.log(
            "filtertemp_data====",
            filtertemp_data,
            schedule_filter,
            filtertemp_data.length === schedule_filter.length
          );
          if (filtertemp_data.length > 0) {
            if (index > item.sessions_week.split("w")[1]) {
              let temp = temp_data;
              console.log("check the temp value---index", temp);
              temp.push(item);
              temp_data = temp;
              console.log(
                "please check the temp_data array---index",
                temp_data
              );
              return item;
            } else {
              if (filtertemp_data.length === schedule_filter.length) {
                let temp = temp_data;
                console.log("check the temp value", temp);
                temp.push(item);
                temp_data = temp;
                console.log("please check the temp_data array", temp_data);
                return item;
              } else {
                let temp = temp_data;
                console.log("check the temp value----sssssyyy---", temp);
                temp.push({ ...item, sessions_week: string });
                temp_data = temp;
                console.log(
                  "please check the temp_data array------sss-",
                  temp_data
                );
                return {
                  ...item,
                  sessions_week: string,
                };
              }
            }
          } else {
            let temp = temp_data;
            console.log("check the temp value-------", temp);
            temp.push({ ...item, sessions_week: string });
            temp_data = temp;
            console.log("please check the temp_data array-------", temp_data);
            return {
              ...item,
              sessions_week: string,
            };
          }
        }
      });
      console.log("trainingDataRead====", trainingDataRead);
      setpushdata([...trainingDataRead]);
      let session_day = selectedDays.filter((item) => item.index !== index);

      let schedule_date = session_day.map((item, i) => {
        if (item.index === 0) {
          return item;
        } else {
          let index_check = session_day.filter((val) => val.index === i - 1);
          console.log("index check karo---", index_check);
          if (index_check.length > 0) {
            return item;
          } else {
            return {
              ...item,
              index: item.index - 1,
            };
          }
        }
      });
      console.log("selcteddays cross", [...schedule_date]);
      setSelectedDays([...schedule_date]);
      console.log("push data read", trainingDataRead);
      console.log("session_day", session_day);
      console.log("schedule_date", schedule_date);
    }
  };
  const onBack = () => {
    props.handleBack();
  };
  const onDaysSelect = (id, index, startDate, endDate, startTime, endTime) => {
    console.log("ggggggggggg", startDate, endDate, startTime, endTime);
    if (endDate === "" || startTime === "" || endTime === "") {
      toast.error(`Please fill the above field!`, {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        style: { background: "#000", color: "#ffffff" },
      });
    } else {
      let selectedDay = pushdata.filter(
        (item) => item.day === id && item.sessions_week === `w${index}`
      );
      let dates = [];
      let days = [];
      var now = endDate;
      let starttime = moment(startTime).format("HH:mm:ss");
      let endtime = moment(endTime).format("HH:mm:ss");
      const theDate = setHours(
        setMinutes(setSeconds(new Date(startDate), 0), 0),
        0
      );
      let d1 = new Date(moment(theDate).format("MM/DD/YYYY"));
      let d2 = new Date(moment(endDate).format("MM/DD/YYYY"));
      while (
        new Date(moment(theDate).format("MM/DD/YYYY")) <=
        new Date(moment(endDate).format("MM/DD/YYYY"))
      ) {
        if (starttime > endtime) {
          let end_time = moment(theDate, "YYYY-MM-DD").add("days", 1);
          let finaldate = {
            session_start_date: moment(new Date(theDate)).format(
              `YYYY-MM-DD ${moment(startTime).format("HH:mm:ss")}`
            ),
            session_end_date: end_time.format(
              `YYYY-MM-DD ${moment(endTime).format("HH:mm:ss")}`
            ),
            day: moment(new Date(theDate)).format("ddd"),
            sessions_week: `w${[index]}`,
          };
          dates.push(finaldate);
          theDate.setDate(theDate.getDate() + 1);
          console.log("before dates----", dates);
        } else {
          let finaldate = {
            session_start_date: moment(new Date(theDate)).format(
              `YYYY-MM-DD ${moment(startTime).format("HH:mm:ss")}`
            ),
            session_end_date: moment(new Date(theDate)).format(
              `YYYY-MM-DD ${moment(endTime).format("HH:mm:ss")}`
            ),
            day: moment(new Date(theDate)).format("ddd"),
            sessions_week: `w${[index]}`,
          };
          dates.push(finaldate);
          console.log("after dates----", dates);
          theDate.setDate(theDate.getDate() + 1);
        }
      }
      {
        let days_check = dates.map((val) => {
          console.log("values data check ----", val);
          let filter_dates = pushdata.map(
            (item) =>
              item.session_start_date === val.session_start_date &&
              item.session_end_date === val.session_end_date &&
              item.day === val.day
          );
          let onDayfunc = dates.map((item) => {
            return item.day;
          });
          if (onDayfunc.includes(id)) {
            dates.map(async (item) => {
              if (item.day === id) {
                let day = selectedDays.filter(
                  (val) => val.id === id && val.index === index
                );
                console.log("day-----day day day ", day);
                if (selectedDays.length > 0) {
                  if (day.length > 0) {
                  } else {
                    console.log("after");
                    await setSelectedDays([
                      ...selectedDays,
                      {
                        id: id,
                        index: index,
                      },
                    ]);
                    sortDays(id, index);
                  }
                } else {
                  await setSelectedDays([
                    ...selectedDays,
                    {
                      id: id,
                      index: index,
                    },
                  ]);
                  sortDays(id, index);
                }
              }
            });
            console.log("selcteddays jjjj", selectedDays);
          } else {
            toast.error(`Selected day does not exist as per your schedule`, {
              position: "bottom-right",
              toastId: "daysAlert",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: { background: "#000", color: "#ffffff" },
            });
          }
          if (selectedDay.length > 0) {
            let weekDay = `w${index}`;
            let resp = pushdata.filter(
              (item) => item.sessions_week !== weekDay
            );
            console.log("resp data -----", resp);
            let temp = pushdata.filter(
              (item) => item.day !== id && item.sessions_week === weekDay
            );
            console.log("temp data -----", temp);
            let dataFilter = temp.concat(resp);
            console.log("dataFilter---", dataFilter);
            setpushdata(dataFilter);
            let data = [...date];
            let data2 = data[index].days.filter((item) => item !== id);
            console.log(" data200000---", data2);
            data[index].days = [...data2];
            setDate([...data]);
            let selectedResponse = selectedDays.filter(
              (item) => !(item.id === id && item.index === index)
            );
            console.log("selctedResponse---", selectedResponse, selectedDays);
            setSelectedDays([...selectedResponse]);
          } else {
            let resp = dates.filter((item) => item.day === id);
            let temp = pushdata;
            let data = resp;
            let data2 = temp.concat(data);
            setpushdata(data2);
          }
          console.log("filter_dates000000", filter_dates, selectedDays);
        });
      }
    }
    console.log("selcteddays", selectedDays);
  };

  const getTrainingData = async () => {
    let data = trainingDetails?.TrainingById?.data?.data;
    let weekData = [];
    let trainingSchedule = [];
    let daysSelected = [];
    let startDate = [];
    let endDate = [];
    if (trainingDetails?.loading === true) {
    } else if (data) {
      await setTrainingVal(data);

      if (data) {
        let weekVal = data.training_dates.map((item, index) => {
          let weekIndex = item.sessions_week
            ? item.sessions_week.split("w")
            : "";

          let week = +weekIndex[1];
          if (weekData[week]) {
            let target = weekData[week];
            target.push(item);
            weekData[week] = target;
            trainingSchedule = weekData;
            console.log("true", target);
          } else {
            let data = weekData;
            data[week] = [item];
            data = weekData;
            trainingSchedule = weekData;
            console.log("false", data);
          }
        });
      }
      console.log("false", weekData);
    }

    if (trainingSchedule) {
      let daysOfWeek = trainingSchedule.map((item) => {
        let day = item.map((val) => {
          let data = val.sessions_week.split("w");
          if (daysSelected[data[1]]) {
            if (daysSelected[data[1]].includes(val.day)) {
            } else {
              let weekDay = daysSelected[data[1]];
              weekDay.push(val.day);
              daysSelected[data[1]] = weekDay;
            }
          } else {
            daysSelected = [...daysSelected, [val.day]];
          }
        });
      });
    }
    if (trainingSchedule && daysSelected) {
      let date = trainingSchedule.map((item, index) => {
        let minDate = new Date(
          Math.min(
            ...item.map((element) => {
              return new Date(element.session_start_date);
            })
          )
        );
        let maxDate = new Date(
          Math.max(
            ...item.map((element) => {
              return new Date(element.session_end_date);
            })
          )
        );
        endDate[index] = moment(maxDate).subtract(15, "minutes").toDate();
        startDate[index] = moment(minDate).add(15, "minutes").toDate();
      });
    }
    console.log("weekData----", weekData);
    let date = weekData.map((item, i) => {
      return {
        startDate:
          new Date(startDate[i]) > new Date()
            ? new Date(startDate[i])
            : new Date(),
        endDate: new Date(endDate[i]),
        startTime: new Date(startDate[i]),
        endTime: new Date(endDate[i]),
        sequence: i,
        days: daysSelected[i],
      };
    });
    let checkWeekData = date.filter(
      (item, i) => new Date(item.endDate) >= new Date()
    );
    let selected_days =
      checkWeekData.length > 0
        ? checkWeekData.map((item, index) => {
            let temp = item.days.map((val) => {
              let data_day = selectedDays;
              data_day.push({
                id: val,
                index: index,
              });
            });
          })
        : "";
    await setDate([...checkWeekData]);
    // if (props.action === "copy") {
    //   if (date.length === 0) {
    //     date = [
    //       {
    //         startDate: setHours(setMinutes(setSeconds(new Date(), 0), 0), 0),
    //         endDate: "",
    //         startTime: "",
    //         endTime: "",
    //         sequence: 0,
    //         days: [],
    //       },
    //     ];
    //   }
    // }

    let training_date_filter = data?.training_dates?.filter(
      (item) => new Date(item.session_end_date) >= new Date()
    );
    const date_filter_value = training_date_filter.map((item) => {
      return {
        ...item,
        session_start_date: moment(item.session_start_date)
          .add(15, "minutes")
          .toDate(),
        session_end_date: moment(item.session_end_date)
          .subtract(15, "minutes")
          .toDate(),
      };
    });
    // console.log(
    //   "date_filter_value----",
    //   date_filter_value,
    //   trainingDetails?.TrainingById?.data?.data
    // );
    await setpushdata(date_filter_value ? [...date_filter_value] : []);
    let add_data = [];
    let unique = [
      ...new Set(date_filter_value.map((item) => item.sessions_week)),
    ];
    // console.log("date_filter_value---nnnn", unique);
    let arr_data = [];
    let trainingDataRead = unique.map((item, i) => {
      console.log("date_filter_value---lll", item, i);
      let add_data = date_filter_value.map((val) => {
        if (item === val.sessions_week) {
          console.log("date_filter_value---eeee", arr_data);
          let data_week = [...arr_data];
          data_week.push({
            ...val,
            sessions_week: `w${i}`,
          });
          arr_data = data_week;
        }
      });
    });
    await setpushdata(arr_data ? [...arr_data] : []);

    let dataOfDay = [];
    let dayFilterData = daysSelected.map((item, i) => {
      let FilterData = checkWeekData.map((val) => {
        if (i === val.sequence) {
          let temp = dataOfDay;
          temp.push(item);
          dataOfDay = temp;
        } else {
        }
      });
    });

    daysSelected = [...dataOfDay];
    console.log("lllcheck----", daysSelected);
    let daySelect = [];
    let scheduledata = daysSelected.map((val, i) => {
      console.log("llmmmniiiiuuu", val);
      let daysData = val.map((value) => {
        const found = daySelect.some((el) => el.id === value && el.index === i);
        if (found.length === 0) {
          let data = daySelect;
          data.push({
            id: value,
            index: i,
          });
          daySelect = data;
        } else {
          let data = daySelect;
          data.push({
            id: value,
            index: i,
          });
          daySelect = data;
        }
      });
    });
    setSelectedDays([...daySelect]);
    console.log("daySelect", daySelect);
  };

  return (
    <>
      <Stack height={"58vh"}>
        {console.log("shzdhhdhfdhsdfsha", selectedDays)}
        {selectedSessionOption?.sessionType === "longtermsession" ? (
          <Stack className='scheduler_container'>
            <Stack
              className={
                gcpSchedule === "Schedule" ? "Scheduler_gcp" : "Scheduler"
              }
            >
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mb: 2 }}>
                <FormControl>
                  {/* <FormLabel
                  id="demo-radio-buttons-group-label"
                  className="formLabel"
                >
                  This session will be used for:
                </FormLabel> */}
                  <RadioGroup
                    aria-labelledby='demo-radio-buttons-group-label'
                    defaultValue={
                      selectedSessionOption?.gcpType
                        ? selectedSessionOption?.gcpType
                        : "Right Now"
                    }
                    name='radio-buttons-group'
                    onChange={handleTrainings}
                    className='formGroup'
                  >
                    <FormControlLabel
                      value='Right Now'
                      control={<BpRadio />}
                      label='Right Now'
                    />
                    <FormControlLabel
                      value='Schedule'
                      control={<BpRadio />}
                      label='Schedule'
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              {gcpSchedule === "Schedule" ? (
                <Grid container spacing={0}>
                  <div className='flexClass flexResize'>
                    <Stack direction='row' className='set-width-input'>
                      <Stack direction='row' className='dateSelectField'>
                        <label className='setFlex'>
                          <DatePicker
                            selected={startDate ? new Date(startDate) : ""}
                            dateFormat='dd/MM/yyyy'
                            onChange={(date) => setStartDate(date)}
                            minDate={new Date()}
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            placeholderText='Start Date'
                            id='startDate'
                          />

                          <img src={Calendar} className='CalendarImg' />
                        </label>
                        {/* <Stack sx={{ width: '25px' }}>
													<img src={Calendar} className="CalendarImg" />
												</Stack> */}
                      </Stack>
                      <Stack sx={{ width: "25px", margin: "12px 10px" }}>
                        <img
                          src={Arrow}
                          // onClick={() => document.getElementById("endDate").click()}
                        />
                      </Stack>
                    </Stack>
                    <Stack direction='row'>
                      {/* <Grid container spacing={0}>
                     <Grid
                       item
                       xs={12}
                       sm={12}
                       md={12}
                       lg={12}
                       xl={12}
                       sx={{ mb: 2 }}
                     >
                       <Typography variant="h6"> End Date</Typography>
                     </Grid>
                   </Grid> */}
                      <Stack direction='row'>
                        <Stack direction='row' className='dateSelectField'>
                          <Stack>
                            {/* <DatePicker
                              selected={startTime ? new Date(startTime) : ""}
                              onChange={(date) => setStartTime(date)}
                              placeholderText="Start Time"
                              showTimeSelect
                              id="startTime"
                              showTimeSelectOnly
                              timeIntervals={15}
                              timeCaption="Time"
                              dateFormat="h:mm aa"
                              autoComplete="off"
                              {...disableStartTimeGcp(
                                startDate ? new Date(startDate) : ""
                              )}
                            /> */}
                            <DatePicker
                              selected={startTime ? new Date(startTime) : ""}
                              onChange={(date) => setStartTime(date)}
                              placeholderText='Start Time'
                              showTimeSelect
                              id='startTime'
                              showTimeSelectOnly
                              timeIntervals={15}
                              timeCaption='Time'
                              dateFormat='h:mm aa'
                              autoComplete='off'
                              onKeyDown={(e) => {
                                e.preventDefault();
                              }}
                              // disabled={endDate ? false : true}
                              {...disableStartTimeGcp(
                                startDate ? new Date(startDate) : ""
                              )}
                            />
                          </Stack>
                          <Stack sx={{ width: "40px" }} className='ClockImg'>
                            <img src={Clock} />
                          </Stack>
                        </Stack>
                        <Stack sx={{ width: "25px", margin: "12px 10px" }}>
                          <img
                            src={Arrow}
                            // onClick={() => document.getElementById("endDate").click()}
                          />
                        </Stack>
                      </Stack>
                      <Stack direction='row' className='dateSelectField'>
                        {console.log(
                          "++++++++++++++++++++++++++++++",
                          startDate
                        )}
                        <label className='setFlex'>
                          <DatePicker
                            selected={endDate ? new Date(endDate) : ""}
                            dateFormat='dd/MM/yyyy'
                            onChange={(date) => setEndDate(date)}
                            minDate={new Date(startDate)}
                            placeholderText='End Date'
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            id='endDate'
                            autoComplete='off'
                            disabled={startTime ? false : true}
                          />
                          <img src={Calendar} className='CalendarImg' />
                        </label>
                        {/* <Stack sx={{ width: '25px' }}>
                         <img src={Calendar} className="CalendarImg" />
                       </Stack> */}
                      </Stack>

                      <Stack sx={{ width: "25px", margin: "12px 10px" }}>
                        <img
                          src={Arrow}
                          // onClick={() => document.getElementById("endDate").click()}
                        />
                      </Stack>
                    </Stack>

                    <Stack direction='row'>
                      <Stack direction='row' className='dateSelectField'>
                        <Stack>
                          <DatePicker
                            selected={endTime ? new Date(endTime) : ""}
                            onChange={(date) => setEndTime(date)}
                            placeholderText='End Time'
                            showTimeSelect
                            id='endTime'
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption='Time'
                            dateFormat='h:mm aa'
                            autoComplete='off'
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            disabled={endDate ? false : true}
                            {...disableEndTimeGcp()}
                            excludeTimes={
                              moment(startTime).format("mm") === "15"
                                ? [
                                    setHours(
                                      setMinutes(new Date(startTime), 0),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH")
                                    ),
                                    // setHours(setMinutes(new Date(startTime), 0), moment(startTime).format("HH") -1),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 30),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH") - 1
                                    ),
                                  ]
                                : moment(startTime).format("mm") === "30"
                                ? [
                                    setHours(
                                      setMinutes(new Date(startTime), 0),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 30),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH") - 1
                                    ),
                                  ]
                                : moment(startTime).format("mm") === "45"
                                ? [
                                    setHours(
                                      setMinutes(new Date(startTime), 0),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 30),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH")
                                    ),
                                  ]
                                : [
                                    setHours(
                                      setMinutes(new Date(startTime), 0),
                                      moment(startTime).format("HH")
                                    ),
                                    // setHours(setMinutes(new Date(startTime), 0), moment(startTime).format("HH")-1),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 30),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH") - 1
                                    ),
                                  ]
                            }
                          />
                        </Stack>
                        <Stack sx={{ width: "40px" }} className='ClockImg'>
                          <img src={Clock} />
                        </Stack>
                      </Stack>
                    </Stack>
                  </div>
                </Grid>
              ) : (
                <Grid container spacing={0}>
                  <div className='flexClass flexResize'>
                    <Stack direction='row'>
                      {/* <Grid container spacing={0}>
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        xl={12}
                        justifyContent="flex-end"
                        //{{ md: 'flex-start', lg: 'flex-end' }}
                        display={"flex"}
                        width="102%"
                        className="cross_scheduler"
                      >
                        <Typography variant="h6"> End Date</Typography>
                      </Grid>
                    </Grid> */}
                      <Stack direction='row' className='dateSelectField'>
                        <label className='setFlex'>
                          <DatePicker
                            selected={endDate ? new Date(endDate) : ""}
                            dateFormat='dd/MM/yyyy'
                            onChange={(date) => setEndDate(date)}
                            minDate={new Date(startDate)}
                            placeholderText='End Date'
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            id='endDate'
                            autoComplete='off'
                          />
                          <img src={Calendar} className='CalendarImg' />
                        </label>
                        {/* <Stack sx={{ width: '25px' }}>
													<img src={Calendar} className="CalendarImg" />
												</Stack> */}
                      </Stack>

                      <Stack sx={{ width: "25px", margin: "12px 10px" }}>
                        <img
                          src={Arrow}
                          // onClick={() => document.getElementById("endDate").click()}
                        />
                      </Stack>
                    </Stack>

                    <Stack direction='row'>
                      <Stack direction='row' className='dateSelectField'>
                        <Stack>
                          <DatePicker
                            selected={endTime ? new Date(endTime) : ""}
                            onChange={(date) => setEndTime(date)}
                            placeholderText='End Time'
                            showTimeSelect
                            id='endTime'
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption='Time'
                            dateFormat='h:mm aa'
                            autoComplete='off'
                            onKeyDown={(e) => {
                              e.preventDefault();
                            }}
                            disabled={endDate ? false : true}
                            {...disableEndTimeGcp("right-now")}
                            excludeTimes={
                              moment(startTime).format("mm") === "15"
                                ? [
                                    setHours(
                                      setMinutes(new Date(startTime), 0),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH")
                                    ),
                                    // setHours(setMinutes(new Date(value.startTime), 0), moment(value.startTime).format("HH") -1),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 30),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH") - 1
                                    ),
                                  ]
                                : moment(startTime).format("mm") === "30"
                                ? [
                                    setHours(
                                      setMinutes(new Date(startTime), 0),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 30),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH") - 1
                                    ),
                                  ]
                                : moment(startTime).format("mm") === "45"
                                ? [
                                    setHours(
                                      setMinutes(new Date(startTime), 0),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 30),
                                      moment(startTime).format("HH")
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH")
                                    ),
                                  ]
                                : [
                                    setHours(
                                      setMinutes(new Date(startTime), 0),
                                      moment(startTime).format("HH")
                                    ),
                                    // setHours(setMinutes(new Date(startTime), 0), moment(startTime).format("HH")-1),
                                    setHours(
                                      setMinutes(new Date(startTime), 15),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 30),
                                      moment(startTime).format("HH") - 1
                                    ),
                                    setHours(
                                      setMinutes(new Date(startTime), 45),
                                      moment(startTime).format("HH") - 1
                                    ),
                                  ]
                            }
                          />
                        </Stack>
                        <Stack sx={{ width: "40px" }} className='ClockImg'>
                          <img src={Clock} />
                        </Stack>
                      </Stack>
                    </Stack>
                  </div>
                </Grid>
              )}
            </Stack>
          </Stack>
        ) : (
          <Stack className='scheduler_container'>
            {date.map((value, index) => {
              return (
                <>
                  <Stack
                    className={
                      index === 0
                        ? "Scheduler overflow_scheduler "
                        : "Scheduler"
                    }
                  >
                    <Grid container spacing={0}>
                      {index === 0 ? (
                        ""
                      ) : (
                        <Grid
                          item
                          xs={12}
                          sm={12}
                          md={12}
                          lg={12}
                          xl={12}
                          justifyContent='flex-end'
                          //{{ md: 'flex-start', lg: 'flex-end' }}
                          display={"flex"}
                          width='102%'
                          className='cross_scheduler'
                        >
                          {/* <Typography
													variant="h6"
													className="cross_over"
													onClick={() => onCross(index)}
												>
													x
												</Typography> */}
                          <img
                            src={CancelImage}
                            className='iamgeCancel'
                            onClick={() => onCross(index)}
                          />
                        </Grid>
                      )}
                      <Grid item xs={11} sm={11} md={11} lg={11} xl={11}></Grid>
                    </Grid>
                    <div className='scheduling_field'>
                      <div className='flexClass flexResize schedule_content'>
                        <Stack direction='row' className='set-width-input'>
                          <Stack direction='row' className='dateSelectField'>
                            <label className='setFlex'>
                              <DatePicker
                                selected={
                                  value.startDate
                                    ? new Date(value.startDate)
                                    : ""
                                }
                                dateFormat='dd/MM/yyyy'
                                onChange={(date) =>
                                  handleStartDate(date, value.sequence)
                                }
                                onKeyDown={(e) => {
                                  e.preventDefault();
                                }}
                                minDate={new Date()}
                                placeholderText='Start Date'
                                id='startDate'
                              />
                              <div>
                                <img src={Calendar} className='CalendarImg' />
                              </div>
                            </label>
                            {/* <Stack sx={{ width: '25px' }}>
													<img src={Calendar} className="CalendarImg" />
												</Stack> */}
                          </Stack>
                        </Stack>

                        <Stack sx={{ width: "25px", margin: "12px 10px" }}>
                          <img
                            src={Arrow}
                            onClick={() =>
                              document.getElementById("startDate").click()
                            }
                          />
                        </Stack>
                        <Stack direction='row'>
                          <Stack direction='row' className='dateSelectField'>
                            <label className='setFlex'>
                              <DatePicker
                                selected={
                                  value.endDate ? new Date(value.endDate) : ""
                                }
                                dateFormat='dd/MM/yyyy'
                                onChange={(date) =>
                                  handleEndDate(date, index, value.startDate)
                                }
                                onKeyDown={(e) => {
                                  e.preventDefault();
                                }}
                                minDate={new Date(value.startDate)}
                                placeholderText='End Date'
                                id='endDate'
                                autoComplete='off'
                              />
                              <img src={Calendar} className='CalendarImg' />
                            </label>
                            {/* <Stack sx={{ width: '25px' }}>
													<img src={Calendar} className="CalendarImg" />
												</Stack> */}
                          </Stack>
                        </Stack>
                        <Stack sx={{ width: "25px", margin: "12px 10px" }}>
                          <img
                            src={Arrow}
                            onClick={() =>
                              document.getElementById("endDate").click()
                            }
                          />
                        </Stack>
                        <Stack direction='row'>
                          <Stack direction='row' className='dateSelectField'>
                            <Stack>
                              <DatePicker
                                selected={
                                  value?.startTime
                                    ? new Date(value.startTime)
                                    : ""
                                }
                                onChange={(date) =>
                                  handleStartTime(date, index)
                                }
                                onKeyDown={(e) => {
                                  e.preventDefault();
                                }}
                                placeholderText='Start Time'
                                showTimeSelect
                                id='startTime'
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption='Time'
                                dateFormat='h:mm aa'
                                autoComplete='off'
                                disabled={value.endDate ? false : true}
                                {...disableStartTime(
                                  value?.startDate
                                    ? new Date(value.startDate)
                                    : "",
                                  index
                                )}
                              />
                            </Stack>
                            <Stack sx={{ width: "40px" }} className='ClockImg'>
                              <img src={Clock} />
                            </Stack>
                          </Stack>
                        </Stack>
                        <Stack sx={{ width: "25px", margin: "12px 10px" }}>
                          <img src={Arrow} />
                        </Stack>
                        <Stack direction='row'>
                          <Stack direction='row' className='dateSelectField'>
                            <Stack>
                              <DatePicker
                                selected={
                                  value?.endTime ? new Date(value.endTime) : ""
                                }
                                onChange={(date) =>
                                  handleEndTime(
                                    date,
                                    index,
                                    value.startDate,
                                    value.endDate,
                                    value.startTime
                                  )
                                }
                                onKeyDown={(e) => {
                                  e.preventDefault();
                                }}
                                placeholderText='End Time'
                                showTimeSelect
                                id='endTime'
                                showTimeSelectOnly
                                timeIntervals={15}
                                timeCaption='Time'
                                dateFormat='h:mm aa'
                                autoComplete='off'
                                disabled={value.startTime ? false : true}
                                {...disableEndTime(
                                  value?.startTime
                                    ? new Date(value.startTime)
                                    : "",
                                  value.startDate,
                                  value.endDate
                                )}
                                excludeTimes={
                                  moment(value.startTime).format("mm") === "15"
                                    ? [
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            0
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            15
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                        // setHours(setMinutes(new Date(value.startTime), 0), moment(value.startTime).format("HH") -1),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            15
                                          ),
                                          moment(value.startTime).format("HH") -
                                            1
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            30
                                          ),
                                          moment(value.startTime).format("HH") -
                                            1
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            45
                                          ),
                                          moment(value.startTime).format("HH") -
                                            1
                                        ),
                                      ]
                                    : moment(value.startTime).format("mm") ===
                                      "30"
                                    ? [
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            0
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            15
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            30
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            45
                                          ),
                                          moment(value.startTime).format("HH") -
                                            1
                                        ),
                                      ]
                                    : moment(value.startTime).format("mm") ===
                                      "45"
                                    ? [
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            0
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            15
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            30
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            45
                                          ),
                                          moment(value.startTime).format("HH") -
                                            1
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            45
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                      ]
                                    : [
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            0
                                          ),
                                          moment(value.startTime).format("HH")
                                        ),
                                        // setHours(setMinutes(new Date(value.startTime), 0), moment(value.startTime).format("HH")-1),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            15
                                          ),
                                          moment(value.startTime).format("HH") -
                                            1
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            30
                                          ),
                                          moment(value.startTime).format("HH") -
                                            1
                                        ),
                                        setHours(
                                          setMinutes(
                                            new Date(value.startTime),
                                            45
                                          ),
                                          moment(value.startTime).format("HH") -
                                            1
                                        ),
                                      ]
                                }
                              />
                            </Stack>
                            <Stack sx={{ width: "40px" }} className='ClockImg'>
                              <img src={Clock} />
                            </Stack>
                          </Stack>
                        </Stack>
                      </div>
                      <Stack sx={{ mt: 3 }} className='flexClass flexResize'>
                        <div className='flexClass flexResize schedule_content'>
                          {days.map((item, i) => {
                            return (
                              <Button
                                value={item.name}
                                role={
                                  value?.days?.includes(item.id)
                                    ? "primary"
                                    : "outlined"
                                }
                                onClick={() => {
                                  onDaysSelect(
                                    item.id,
                                    index,
                                    value.startDate,
                                    value.endDate,
                                    value.startTime,
                                    value.endTime
                                  );
                                }}
                                className='DaysBetween'
                              />
                            );
                          })}
                        </div>
                      </Stack>
                    </div>
                  </Stack>
                </>
              );
            })}
          </Stack>
        )}
        {selectedSessionOption?.sessionType === "longtermsession" ? (
          ""
        ) : (
          <Stack className='MoreScheduler '>
            <Typography
              variant='h6'
              className='Schedulerheading'
              onClick={() => handleScheduler()}
            >
              {" "}
              <span className='add_span'> +</span> Add Another Schedule
            </Typography>
          </Stack>
        )}
      </Stack>
      <Stack className='btmAssign'></Stack>
      <div className='flexClass btmAssign'>
        <Button
          value='Back'
          role='default'
          onClick={() => {
            props.action === "reschedule" ? navigate("/training") : onBack();
          }}
        />

        <Button
          value={props.action === "reschedule" ? "Reschedule" : "Continue"}
          onClick={() => onSubmit()}
          role='primary'
        />
      </div>
      {isLoading && <MultiLine_Spinner />}
    </>
  );
}

export default ScheduleTraining;
